import React, { useEffect, useState } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

function TabComponent({ content, defaultTabIndex = 0, selectedTabIndex, onTabChange }) {
  const [tabIndex, setTabIndex] = useState(defaultTabIndex)

  useEffect(() => {
    selectedTabIndex && setTabIndex(selectedTabIndex)
  }, [selectedTabIndex])

  useEffect(() => {
    onTabChange && onTabChange(tabIndex)
  }, [tabIndex])

  return (
    <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
      <TabList>
        { content && content.map(x => <Tab>{x.title}</Tab>) }        
      </TabList>
      
      { 
        content && content.map(x => {
          return (
            <TabPanel>{x.content}</TabPanel>
          )
        }) 
      }
    </Tabs>
  )
}

export default TabComponent



// WEBPACK FOOTER //
// ./src/component/Tab/TabComponent.js